const CLASS_SEARCH_ACTIVE = 'is-search-active';
const CLASS_CROSS_ACTIVE = 'is-cross-active';

export default class Search {
    constructor(element) {
        this.el = element;
        this.active = false;
        this.crossActive = false;

        this._initialize();
        this._connect();
    }

    _initialize() {
        // Bind event handlers
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onClickCross = this.onClickCross.bind(this);
    }

    _connect() {
        if (!this.el) return;

        this.search = this.el.querySelector('[search]');
        this.input = this.search.querySelector('input');
        this.cross = this.search.querySelector('[search-cross]');

        // Add event listeners
        this.input.addEventListener('focus', this.onFocus);
        this.input.addEventListener('blur', this.onBlur);
        this.input.addEventListener('input', this.onInput);
        this.cross.addEventListener('click', this.onClickCross);

        // Set initial state based on input value
        if (this.input.value.trim() !== '') {
            this.active = true;
            this.search.classList.add(CLASS_SEARCH_ACTIVE);
            this.crossActive = true;
            this.cross.classList.add(CLASS_CROSS_ACTIVE);
        }
    }

    _disconnect() {
        // Remove event listeners for cleanup
        this.input.removeEventListener('focus', this.onFocus);
        this.input.removeEventListener('blur', this.onBlur);
        this.input.removeEventListener('input', this.onInput);
        this.cross.removeEventListener('click', this.onClickCross);
    }

    onClickCross() {
        this.input.value = '';
        this.active = false;
        this.crossActive = false;
        this.search.classList.remove(CLASS_SEARCH_ACTIVE);
        this.cross.classList.remove(CLASS_CROSS_ACTIVE);
    }

    onInput() {
        if (!this.active) return;

        if (this.input.value.trim() !== '') {
            if (!this.crossActive) {
                this.crossActive = true;
                this.cross.classList.add(CLASS_CROSS_ACTIVE);
            }
        } else {
            this.crossActive = false;
            this.cross.classList.remove(CLASS_CROSS_ACTIVE);
        }
    }

    onFocus() {
        if (this.active) return;
        this.active = true;
        this.search.classList.add(CLASS_SEARCH_ACTIVE);
    }

    onBlur() {
        if (!this.active || this.input.value.trim() !== '') return;
        this.active = false;
        this.search.classList.remove(CLASS_SEARCH_ACTIVE);
    }

    // Optional cleanup method to call when you want to remove event listeners
    destroy() {
        this._disconnect();
    }
}
